import { useLocation } from 'react-router';
import { gtmUtil } from './gtmUtils';

export const GoogleTagListener = () => {
    const location = useLocation();
    return <>{gtmUtil.triggerPageViewFromLocation(location)}</>;
};
